@if (isExternalUrl()) {
<a
  role="link"
  [href]="url"
  [attr.target]="target"
  [attr.rel]="rel"
  [attr.class]="class"
  [attr.id]="id"
  [attr.style]="style"
  [attr.title]="title"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>
} @else { @if (location === 'footer') {
<a
  role="link local"
  [routerLink]="routerUrl"
  [attr.target]="target"
  [attr.class]="class"
  [attr.id]="id"
  [attr.style]="style"
  [attr.title]="title"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>
} @else {
<a
  role="link"
  [href]="routerUrl"
  [attr.target]="target"
  [attr.class]="class"
  [attr.id]="id"
  [attr.style]="style"
  [attr.title]="title"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</a>
} }

<ng-template #content>
  @if (linkIconSrc) {
  <img [src]="setImageUrl(linkIconSrc)" [class]="linkIconStyleClass" />
  }
  <ng-content></ng-content>
  @if (location !== 'footer') { @if (!icon) { @if (isDesktop()) {
  <mat-icon class="material-icons-sharp light" [attr.title]>system_update_alt</mat-icon>
  } @else {
  <mat-icon class="material-icons-sharp light" [attr.title]>keyboard_arrow_right</mat-icon>
  } } @else {
  <mat-icon class="material-icons-sharp light manual-arrow" [attr.title]>keyboard_arrow_right</mat-icon>
  } }
</ng-template>
